<template>
  <div>
    	<v-card class="filter-card">
    	 	<v-card-title primary-title nopadding>
    	 	  	<v-btn icon flat @click="closeFilters"><v-icon>close</v-icon></v-btn>
    	 	  	Filters
    	 	  	<v-spacer></v-spacer>
    	 	  	<v-btn color="primary" flat @click="fn_clearAllFilters">Clear All</v-btn>
    	 	</v-card-title>

    	 	<v-divider></v-divider>

    	 	<v-card-text nopadding>
    	 		<v-layout row wrap padding-top-ten>

                    <v-flex xs12 sm12 md12 form-item v-if="propsObj.itemLabel" @click="openDialogAndroid">
                        <v-text-field  
                            readonly
                            v-model="propsObj.itemName" 
                            :label="propsObj.itemLabel" 
                            placeholder=" "
                            append-icon="arrow_drop_down">
                        </v-text-field>
                    </v-flex>

                    <!-- <v-flex xs6 sm6 md6 pl-3 pr-2 v-if="propsObj.startDate" @click="openDatePicker('start', propsObj.startDate)">
                        <v-text-field  
                            readonly
                            :value="fn_formatDate(propsObj.startDate)"
                            label="Start Date" 
                            placeholder=" "
                            append-icon="arrow_drop_down">
                        </v-text-field>
                    </v-flex>

                    <v-flex xs6 sm6 md6 pr-3 pl-2 :class="{'xs12 sm12 md12 pl-3': !propsObj.startDate}" @click="openDatePicker('end', propsObj.endDate)">
                        <v-text-field  
                            readonly
                            :value="fn_formatDate(propsObj.endDate)"
                            :label="propsObj.periodLabel=='Period' ? 'End Date' : propsObj.periodLabel" 
                            placeholder=" "
                            append-icon="arrow_drop_down">
                        </v-text-field>
                    </v-flex> -->

                    <v-flex xs12 sm12 md12 form-item v-for="(item, index) in $root.reportFilters" :key="index" @click="fn_openFilterDialog(item)" v-if="isFilterApplicable(item.reportIds)">
                        <v-text-field  
                            readonly
                            v-model="item.value" 
                            :label="item.label" 
                            placeholder=" "
                            append-icon="arrow_drop_down"
                            :ref="item.ref" 
                            required>
                        </v-text-field>
                    </v-flex>

    	 		</v-layout>

                <v-layout row wrap v-if="$route.params && ($route.params.reportid==304 || $route.params.reportid==305 || $route.params.reportid==404 || $route.params.reportid==405)">
                    <v-subheader form-section-header form-item>Status
                        <v-spacer></v-spacer>
                    </v-subheader>

                    <v-flex xs12 sm12 md12 form-item>
                        <v-radio-group v-model="filterModel.status" row @change="fn_orderChallanStatus">
                          <v-radio label="All" value="All"></v-radio>
                          <v-radio label="Open" value="Open"></v-radio>
                          <v-radio label="Close" value="Close"></v-radio>
                        </v-radio-group>
                    </v-flex>
                </v-layout>

                <v-layout row wrap v-if="$route.params && $route.params.reportid==503">
                    <v-flex xs12 sm12 md12 form-item>
                        <v-radio-group v-model="filterModel.groupTypeId" row @change="fn_outstandingType">
                          <v-radio label="All" value="All"></v-radio>
                          <v-radio label="To Receive" value="Receivables"></v-radio>
                          <v-radio label="To Pay" value="Payables"></v-radio>
                        </v-radio-group>
                    </v-flex>
                </v-layout>

                <v-layout row wrap v-if="$route.params && $route.params.reportid==105">
                    <v-flex xs12 sm12 md12 form-item>
                        <v-checkbox label="Show Out of Stock" v-model="filterModel.showOutOfStock" @change="fn_showHideOutofStock"></v-checkbox>
                    </v-flex>
                </v-layout>

                <v-layout row wrap v-if="$route.params && $route.params.reportid==504 || $route.params.reportid==505">
                    <v-flex xs10 sm10 md10 form-item>
                        <v-text-field  
                            type="number"
                            v-model.number="filterModel.dueDays" 
                            label="Due Days" 
                            placeholder=" ">
                        </v-text-field>
                    </v-flex>

                    <v-flex xs2 sm2 md2 form-item center-align style="display: flex;align-items: center;justify-content: center;">
                        <v-btn color="primary" flat small @click="fn_dueDays">apply</v-btn>
                    </v-flex>
                    
                    <v-flex xs12 sm12 md12 form-item v-if="$route.params.reportid==504">
                        <v-checkbox label="Show MSME" v-model="filterModel.showMSME" @change="fn_showMSME"></v-checkbox>
                    </v-flex>
                </v-layout>

                <v-layout row wrap v-if="$route.params.reportid==109">
                    <v-flex xs12 sm12 md12 form-item>
                        <v-select
                            :items="['Today', '7 Days', '10 Days', '15 Days', '30 Days', '45 Days', '60 Days', '90 Days', 'Custom']"
                            label="Expire In"
                            placeholder=" "
                            v-model="filterModel.batchExpireIn"
                            @change="fn_batchExpireIn"
                        ></v-select>
                    </v-flex>

                    <template v-if="filterModel.batchExpireIn == 'Custom'">
                        <v-flex xs9 sm9 md9 form-item>
                            <v-text-field
                                name="Custom_Days"
                                label="Enter Number of Days"
                                v-model="filterModel.batchExpireInCustom"
                                placeholder=" "
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs3 sm3 md3 style="display: flex;align-items: center;justify-content: center;">
                            <v-btn color="primary" flat small @click="fn_batchExpireInCustom(filterModel.batchExpireInCustom)">apply</v-btn>
                        </v-flex>
                    </template>

                    <v-flex xs12 sm12 md12 form-item>
                        <v-checkbox label="Show Expire Batches" v-model="filterModel.showAllBatch" @change="fn_showAllBatch"></v-checkbox>
                    </v-flex>
                </v-layout>

                <v-layout row wrap v-if="$route.params && $route.params.reportid==301">
                    <v-flex xs12 sm12 md12 form-item>
                        <v-radio-group v-model="filterModel.itemGroupType" row @change="fn_itemGroupType">
                            <v-radio label="All" value="All"></v-radio>
                            <v-radio label="Goods" value="Goods"></v-radio>
                            <v-radio label="Service" value="Service"></v-radio>
                        </v-radio-group>
                    </v-flex>
                </v-layout>

                <v-layout row wrap v-if="$route.params && $route.params.reportid==102">
                    <v-flex xs12 sm12 md12 form-item>
                        <v-radio-group v-model="filterModel.stockType" row @change="fn_stockType">
                            <v-radio label="All" value="All"></v-radio>
                            <v-radio label="Positive" value="Positive"></v-radio>
                            <v-radio label="Negative" value="Negative"></v-radio>
                        </v-radio-group>
                    </v-flex>

                    <v-flex xs12 sm12 md12 form-item>
                        Sort By:
                        <v-radio-group v-model="filterModel.stockSummarySortBy" row @change="fn_stockSummarySortBy">
                            <v-radio label="Product Name" value="Product Name"></v-radio>
                            <v-radio label="Category Name" value="Category Name"></v-radio>
                        </v-radio-group>
                    </v-flex>

                    <!-- <v-flex xs12 sm12 md12 form-item>
                        <v-select
                            @change="fn_stockSummarySortBy"
                            :items="['Product Name', 'Category Name']"
                            v-model="filterModel.stockSummarySortBy"
                            placeholder=" "
                            label="Sort By"
                        ></v-select>
                    </v-flex> -->
                </v-layout>

                <v-layout row wrap v-if="$route.params && $route.params.reportid==901">
                    <v-flex xs12 sm12 md12 form-item>
                        <v-checkbox label="Zero Balance Ledgers" v-model="filterModel.showZeroBalanceLedgers" @change="fn_showZeroBalanceLedgers"></v-checkbox>
                    </v-flex>
                </v-layout>
    	 	</v-card-text>
    	</v-card>
  </div>
</template>

<script>
	export default{
        props:['applyFilter', 'openFilterDialog', 'closeFilters', 'closeDialog', 'propsObj', 'openDialogAndroid', 'openDatePicker', 'clearAllFilters', 'openDialogTaxRateList'],
		data(){
			return{
				// filters:[
    //                 {"label":"Party", "id":null, "value":null, "ref":"ref_fieldParty", "dialogName":"accounts", "reportIds":[101, 202, 203, 301, 303, 304, 305, 401, 403, 404, 405]},
    //                 {"label":"Item", "id":null, "value":null, "ref":"ref_fieldItem", "dialogName":"product"},
    //                 {"label":"Category", "id":null, "value":null, "ref":"ref_fieldCategory", "dialogName":"productCategories", "reportIds":[102, 103, 301, 401]},
    //                 {"label":"Brand", "id":null, "value":null, "ref":"ref_fieldBrand", "dialogName":"listItems", "reportIds":[102, 103, 301, 401]},
    //                 {"label":"Transaction Form", "id":null, "value":null, "ref":"ref_fieldTransactionForm", "dialogName":"transactionTypeForm", "reportIds":[202, 303, 403]},
    //                 {"label":"Tax Type", "id":null, "value":null, "ref":"ref_fieldTaxType", "dialogName":"accounts", "reportIds":[303, 403]},
    //                 {"label":"Account Group", "id":null, "value":null, "ref":"ref_fieldAccountGroup", "dialogName":"accountgroups", "reportIds":[302, 402]},
    //             ],
                // filterObj:{},
                filterModel:{"status":"All", "groupTypeId":"All", "showOutOfStock":false, "dueDays":null, "showMSME":false, "showAllBatch":false, "itemGroupType":"All", "batchExpireIn":null, "batchExpireInCustom":null, "stockType":null, "stockSummarySortBy":null, "showZeroBalanceLedgers":false},
                filterCalled:false
            }
		},
		methods:{
            fn_formatDate: function(date){
                return this.$moment(date).format('DD-MMM-YYYY');
            },

            fn_orderChallanStatus: function(value){
                console.log(value);
                this.applyFilter(null, value, 'status')
            },

            fn_outstandingType: function(value){
                console.log(value);
                this.applyFilter(null, value, 'groupTypeId');
            },

            fn_itemGroupType: function(value){
                this.applyFilter(null, value, 'itemGroupType');
            },

            fn_stockType: function(value){
                this.applyFilter(null, value, 'stockType');
            },

            fn_stockSummarySortBy: function(value){
                this.applyFilter(null, value, 'stockSummarySortBy');
            },

            fn_dueDays: function(){

                if(!this.filterCalled){
                    this.filterCalled = true;
                    let value = this.filterModel.dueDays ? this.filterModel.dueDays : null;
                    this.applyFilter(null, value, 'dueDays');
                }

                setTimeout(() => {
                    this.filterCalled = false;
                }, 1000);

            },

            // fn_updateItem: function(selectedValueId, selectedValueName, isRemoved, ref){
            //     for(let i=0; i<this.$root.reportFilters.length; i++){
            //         if(this.$root.reportFilters[i].ref == ref){
            //             if(!isRemoved){
            //                 this.$root.reportFilters[i].id = selectedValueId;
            //                 this.$root.reportFilters[i].value = selectedValueName;
            //                 this.fn_getReport(selectedValueId, selectedValueName, ref);
            //                 break;
            //             }
            //             else{
            //                 this.$root.reportFilters[i].id = null;
            //                 this.$root.reportFilters[i].value = null;
            //                 this.closeDialog();
            //                 this.fn_getReport(null, null, ref);
            //                 break;
            //             }
            //         }
            //     }
            // },

            fn_openFilterDialog: function(item){
                if(item.ref == 'ref_compTaxRate'){
                    this.openDialogTaxRateList();
                }
                else{
                    this.openFilterDialog(item.label, item.ref, item.id, item.value, item.dialogName);
                }
            },

            // fn_getReport: function(selectedValueId, selectedValueName, ref){
            //     this.closeFilters();

            //     if(ref=='ref_fieldParty')
            //         selectedValueId ? this.$root.reportFilterObj.party = {"id":selectedValueId, "name":"Party", "value":selectedValueName}: delete this.$root.reportFilterObj.party;
            //     if(ref=='ref_fieldItem')
            //         selectedValueId ? this.$root.reportFilterObj.product = {"id":selectedValueId, "name":"Product", "value":selectedValueName}: delete this.$root.reportFilterObj.product;
            //     if(ref=='ref_fieldCategory')
            //         selectedValueId ? this.$root.reportFilterObj.category = {"id":selectedValueId, "name":"Category", "value":selectedValueName}: delete this.$root.reportFilterObj.category;
            //     if(ref=='ref_fieldBrand')
            //         selectedValueId ? this.$root.reportFilterObj.brand = {"id":selectedValueId, "name":"Brand", "value":selectedValueName}: delete this.$root.reportFilterObj.brand;
            //     if(ref=='ref_fieldTaxType')
            //         selectedValueId ? this.$root.reportFilterObj.taxType = {"id":selectedValueId, "name":"Tax Type", "value":selectedValueName}: delete this.$root.reportFilterObj.taxType;
            //     if(ref=='ref_fieldTransactionForm')
            //         selectedValueId ? this.$root.reportFilterObj.transactionTypeForm = {"id":selectedValueId, "name":"Transaction Form", "value":selectedValueName}: delete this.$root.reportFilterObj.transactionTypeForm;
            //     if(ref=='ref_fieldAccountGroup')
            //         selectedValueId ? this.$root.reportFilterObj.accountGroup = {"id":selectedValueId, "name":"Account Group", "value":selectedValueName}: delete this.$root.reportFilterObj.accountGroup;
            //     if(ref=='status')
            //         selectedValueName ? this.$root.reportFilterObj.status = {"id":null, "name":"Status", "value":selectedValueName}: delete this.$root.reportFilterObj.status;
            //     if(ref=='ref_compTaxRate')
            //         selectedValueName ? this.$root.reportFilterObj.taxRate = {"id":null, "name":"Tax Rate", "value":selectedValueName}: delete this.$root.reportFilterObj.taxRate;

            //     this.getReportData(this.$root.reportFilterObj);
            // },

            fn_clearAllFilters: function(){
                console.log('clear filter');
                for(let i=0; i<this.$root.reportFilters.length; i++){
                    this.$root.reportFilters[i].id = null;
                    this.$root.reportFilters[i].value = null;
                }
                this.$root.reportFilterObj = {};
                this.filterModel.status = "All";
                this.filterModel.groupTypeId = "All";
                this.filterModel.showOutOfStock = false;
                this.filterModel.dueDays = null;
                this.filterModel.showMSME = false;
                this.filterModel.showAllBatch = false;
                this.filterModel.batchExpireIn = null;
                this.filterModel.batchExpireInCustom = null;
                this.filterModel.itemGroupType = "All";
                this.filterModel.stockType = null;
                this.filterModel.stockSummarySortBy = null;
                this.filterModel.showZeroBalanceLedgers = false;
                this.clearAllFilters(this.$root.reportFilterObj);
            },

            isFilterApplicable: function(reportIds){
                if((reportIds && reportIds.length) && (this.$route.params && this.$route.params.reportid)){
                    if(reportIds.indexOf(Number(this.$route.params.reportid))!=-1){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
            },

            fn_showHideOutofStock: function(value){
                this.applyFilter(null, value, 'showoutofstock');
            },

            fn_showMSME: function(value){
                this.applyFilter(null, value, 'showmsme');
            },

            fn_showAllBatch: function(value){
                this.applyFilter(null, value, 'showAllBatch');
            },

            fn_showZeroBalanceLedgers: function(value){
                this.applyFilter(null, value, 'showZeroBalanceLedgers');
            },

            fn_batchExpireIn: function(value){
                if(value && value != 'Custom'){
                    this.applyFilter(null, value, 'batchExpireIn');
                }
            },

            fn_batchExpireInCustom: function(value){
                let isCalled = false;
                if(!isCalled){
                    isCalled = true;
                    setTimeout(() => {
                        isCalled = false;
                        let dayLabel = value == 1 ? 'Day' : 'Days';
                        let val = value ? value + ' ' + dayLabel : null;
                        this.applyFilter(null, val, 'batchExpireIn');
                    }, 300);
                } 
            },
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/newreports/report_templates/filter.vue